import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "types/authTypes";
import { UserProfile } from "types/userTypes";

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  accessToken: sessionStorage.getItem("accessToken") || null,
  refreshToken: sessionStorage.getItem("refreshToken") || null,
  tokenType: sessionStorage.getItem("tokenType") || null,
  loading: false,
  initialized: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserProfile>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    setUserProfile: (state, action: PayloadAction<string>) => {
      state.user = { ...state.user, avatar: action.payload };
    },
    setTokens: (
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        tokenType: string;
      }>
    ) => {
      const { accessToken, refreshToken, tokenType } = action.payload;

      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.tokenType = tokenType;
      state.isAuthenticated = true;
      sessionStorage.setItem("accessToken", accessToken);
      sessionStorage.setItem("refreshToken", refreshToken);
      sessionStorage.setItem("tokenType", tokenType);
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      sessionStorage.setItem("accessToken", action.payload);
    },
    clearAuth: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.tokenType = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.initialized = true;

      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("tokenType");
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.tokenType = null;
      state.initialized = true;
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("tokenType");
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.initialized = action.payload;
    },
  },
});

export const {
  setUser,
  setUserProfile,
  setTokens,
  setAccessToken,
  clearAuth,
  logout,
  setLoading,
  setInitialized,
} = authSlice.actions;
export default authSlice.reducer;
